import { PermissionRepository } from "../../repositories/PermissionRepository";
import { RolePermissionsEntity } from "../../entities/PermissionEntity";

/**
 * Get Role Permissions Use Case
 * Retrieves role permissions with review policies
 */
export class GetRolePermissionsUseCase {
  constructor(private repository: PermissionRepository) {}

  async execute(roleId: number): Promise<RolePermissionsEntity> {
    if (!roleId || roleId <= 0) {
      throw new Error("Role ID is required");
    }

    return await this.repository.getRolePermissions(roleId);
  }
}
